import { metadata } from "lacinetek-common/src/metadata"


import { Bonuses, Info, List, Tvod } from "components/subscription/block"
import { BlockHeader } from "components/subscription/block-header"
import { BlockHeaderSquare } from "components/subscription/block-header-square"
import { Others } from "components/subscription/others"
import { Guest } from "components/subscription/guest"

const SVOD_OVERLAY_TYPE = "Overlay type"

export const BlockOverlay = ({ block }) => (
	<>
		{metadata(block, SVOD_OVERLAY_TYPE) === "carre"
			? <BlockHeaderSquare block={block} inOverlay />
			: <BlockHeader block={block} inOverlay />
		}
		<Info block={block} />
		<List block={block} />
		<Bonuses block={block} />
		{
			metadata(block, SVOD_OVERLAY_TYPE) === "selection du mois"
			&& <Guest block={block} />
		}
		<Tvod block={block} />
		{metadata(block, SVOD_OVERLAY_TYPE) === "selection du mois" && (
			<Others isSvod />
		)}
	</>
)
